var map = {
	"./Token_1.png": 602,
	"./Token_10.png": 603,
	"./Token_100.png": 604,
	"./Token_25.png": 605,
	"./Token_5.png": 606,
	"./Token_Black_100.png": 607,
	"./Token_Blue_10.png": 608,
	"./Token_Green_25.png": 609,
	"./Token_Red_5.png": 610,
	"./Token_White_1.png": 611
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 601;